import { useMemo, useState } from "react";
import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ModalUnidadesDisponibles({ visible = false, onClose, unidades = [] }) {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUnidades = useMemo(() => {
    if (!Array.isArray(unidades)) return [];
    const term = String(searchTerm || "").trim().toLowerCase();
    if (!term) return unidades;
    return unidades.filter((item) =>
      JSON.stringify(item).toLowerCase().includes(term)
    );
  }, [unidades, searchTerm]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-5xl max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 flex-shrink-0">
          <h3 className="text-lg font-semibold text-gray-900 m-0">
            {t("label_unidades_disponibles")}
          </h3>
          <button
            type="button"
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={onClose}
            aria-label={t("label_cerrar")}
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>

        <div className="px-4 pt-4">
          <div className="relative">
            <Search className="h-4 w-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={t("grilla_placeholderbuscar")}
              className="w-full border border-gray-300 rounded-md pl-9 pr-3 py-2 text-sm"
            />
          </div>
        </div>

        <div className="flex-1 min-h-0 p-4 overflow-y-auto">
          {filteredUnidades.length === 0 ? (
            <div className="text-sm text-gray-500">{t("label_no_hay_informacion_disponible")}</div>
          ) : (
            <div className="space-y-3">
              {filteredUnidades.map((unidad, index) => (
                <div
                  key={unidad?.id || `${unidad?.valuePlaca || "unidad"}-${index}`}
                  className="border border-gray-200 rounded-lg p-3"
                >
                  <div className="grid grid-cols-12 gap-3 text-sm">
                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>id:</strong> {String(unidad?.id ?? "-")}</div> */}
                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>valuePlaca:</strong> {String(unidad?.valuePlaca ?? "-")}</div> */}
                    <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>{t("column_vehiculo")}:</strong> {String(unidad?.labelPlaca ?? "-")}</div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>{t("column_nombre_conductor")}:</strong> {String(unidad?.nombreConductor ?? "-")}</div>
                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>idPais:</strong> {String(unidad?.idPais ?? "-")}</div> */}
                    <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>{t("column_pais")}:</strong> {String(unidad?.pais ?? "-")}</div>
                    {/* <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>idCiudad:</strong> {String(unidad?.idCiudad ?? "-")}</div> */}
                    <div className="col-span-12 md:col-span-6 lg:col-span-4"><strong>{t("column_ciudad")}:</strong> {String(unidad?.ciudad ?? "-")}</div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-2"><strong>{t("column_peso")}:</strong> {String(unidad?.peso ?? "-")}</div>
                    <div className="col-span-12 md:col-span-6 lg:col-span-2"><strong>{t("column_volumen")}:</strong> {String(unidad?.volumen ?? "-")}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
